import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export const nutritionistsAdapter = createEntityAdapter({
  selectId: nutritionist => nutritionist._id,
  sortComparer: (nutritionistA, nutritionistB) => {
    if (nutritionistA.assignedPasses > nutritionistB.assignedPasses) return -1;
    if (nutritionistA.assignedPasses < nutritionistB.assignedPasses) return 1;
    return 0;
  },
});

export const nutritionistsSlice = createSlice({
  name: 'wnNutritionists',
  initialState: nutritionistsAdapter.getInitialState,
  reducers: {
    setNutritionists: nutritionistsAdapter.setAll,
  },
});

export const { setNutritionists } = nutritionistsSlice.actions;

export const WnNutritionistsReducer = nutritionistsSlice.reducer;
